import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";

import { LocalizationModule, SharedModule } from 'src/core/index/shared.module.index';
import { AuthGuard, CourseCompletedGuard } from "src/index/services.index";
import { GlobalCalendarComponent } from "src/index/components.index";

const routes: Routes = [ // Rotte definite ma RoutingModule non configurato, per poter gestire eventuale override da app esterna
    {
        path: 'calendar',
        canActivate: [AuthGuard],
        component: GlobalCalendarComponent,
    },
];

@NgModule({
    declarations: [
        GlobalCalendarComponent,
    ],
    imports: [
        CommonModule,
        LocalizationModule,
        SharedModule,
    ],
    providers: [
        AuthGuard,
        CourseCompletedGuard,
    ],
    exports: [
        GlobalCalendarComponent,
    ],
})
export class GlobalCalendarModule {
    getRoutes() {
        return routes;
    }
}
